import React from "react";
import { Drawer, Button, Skeleton } from "antd";
import { isMobile } from "react-device-detect";

const FTDrawer = ({ visible = false, title = "", onClose, onDelete, onSubmit, loading = false, okText, ...props }) => {
  return (
    <Drawer
      title={<div style={{ fontWeight: "500" }}>{title}</div>}
      width={isMobile ? "80%" : "40%"}
      onClose={() => onClose()}
      open={visible}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div
          style={{
            textAlign: "right",
          }}
        >
          <Button onClick={() => onClose()} style={{ marginRight: 8 }}>
            Хаах
          </Button>
          {onDelete ? (
            <Button onClick={() => onDelete()} type="danger" style={{ marginRight: 8 }}>
              Устгах
            </Button>
          ) : null}
          {onSubmit ? (
            <Button onClick={() => onSubmit()} type="primary">
              {okText ? okText : "Хадгалах"}
            </Button>
          ) : null}
        </div>
      }
      {...props}
    >
      <Skeleton loading={loading} active>
        {props.children}
      </Skeleton>
    </Drawer>
  );
};

export default FTDrawer;
